/** L'entree : connexion, inscription, adresse, choix du spot. */
export const auth = {
  erreurs: {
    identifiants: 'Identifiants incorrects',
    emailInvalide: 'Adresse e-mail invalide',
    compteExiste: 'Un compte existe déjà avec cet e-mail',
    motDePasseFaible: 'Mot de passe trop faible',
    tropDeTentatives: 'Trop de tentatives, réessaie dans quelques minutes',
    reseau: 'Connexion impossible, vérifie ton réseau',
    inattendue: 'Une erreur est survenue, réessaie dans un instant',
    parEmail: 'Connecte-toi avec ton adresse e-mail',
    age: 'Sirocco est réservé aux 16 ans et plus',
    pseudoPris: "Ce nom d'utilisateur est déjà pris",
    sessionExpiree: 'Session expirée, reconnecte-toi',
    motDePasseActuel: 'Mot de passe actuel incorrect',
    sansProfil: "Ce compte n'a pas encore de profil Sirocco. Contacte-nous si le problème persiste.",
    connexion: 'Connexion impossible',
  },
  champs: {
    email: 'Adresse e-mail',
    exempleEmail: 'vous@exemple.com',
    motDePasse: 'Mot de passe',
    retourConnexion: 'Retour à la connexion',
  },
  action: {
    incomplet: 'Ce lien est incomplet.',
    expireNouveau: 'Ce lien a expiré ou a déjà servi. Demandes-en un nouveau.',
    expire: 'Ce lien a expiré ou a déjà servi.',
    sixCaracteres: 'Six caractères au minimum.',
    pasChange: "Le mot de passe n'a pas pu être changé. Le lien a peut-être expiré.",
    titreChange: 'MOT DE PASSE CHANGÉ',
    titreNouveau: 'NOUVEAU MOT DE PASSE',
    titreRetablie: 'ADRESSE RÉTABLIE',
    titreConfirmee: 'ADRESSE CONFIRMÉE',
    unInstant: 'UN INSTANT',
    nouveau: 'Nouveau mot de passe',
    changer: 'Changer mon mot de passe',
    connecteToi: 'Tu peux te connecter avec ton nouveau mot de passe.',
    bienvenue: 'Ton compte est ouvert. Bienvenue.',
    ouvrir: 'Ouvrir Sirocco',
    continuerSite: 'Continuer sur le site',
    pour: { avant: 'Choisis un nouveau mot de passe pour', apres: '.' },
  },
  spot: {
    impossible: 'Impossible de rejoindre ce serveur',
    publics: 'Serveurs publics',
    prives: 'Serveurs privés',
    bientot: 'Bientôt',
    tuEsMembre: 'Tu es membre de ce serveur',
    membre: 'Membre de ce serveur',
    badgePrive: 'Privé',
    reserve: 'Réservé à ses membres',
    rechercher: 'Rechercher une ville, une région...',
    rechercherLabel: 'Rechercher une ville ou une région',
    accesReserve: 'Accès réservé aux membres',
    rejoindre: 'Rejoindre ce serveur',
    membres: (n: number) => `${n.toLocaleString('fr-FR')} membre${n > 1 ? 's' : ''}`,
    aucun: (recherche: string) => `Aucun serveur ne correspond à « ${recherche} »`,
    prive: (nom: string) => `${nom} est un serveur privé : seuls ses membres peuvent y entrer.`,
  },
  confirmer: {
    titre: 'CONFIRME TON ADRESSE',
    renvoye: 'Courriel renvoyé.',
    patiente: 'Un courriel vient de partir. Attends une minute avant d’en redemander un, et pense à regarder dans les indésirables.',
    trop: 'Trop de courriels demandés aujourd’hui. Réessaie demain, ou regarde dans les indésirables.',
    echec: 'L’envoi n’a pas abouti. Réessaie.',
    renvoyer: 'Renvoyer le courriel',
    deconnecter: 'Me déconnecter',
    envoye: {
    avant: 'Un courriel de confirmation a été envoyé à',
    apres: '. Appuie sur le lien qu’il contient pour accéder à l’application.',
  },
  },
  oubli: {
    impossible: 'Envoi impossible',
    titre: 'MOT DE PASSE',
    consigne: "Renseigne ton e-mail, on t'envoie un lien de réinitialisation.",
    envoyer: 'Envoyer le lien',
    envoye: (email: string) => `Si un compte existe pour ${email}, un e-mail vient de partir.`,
  },
  connexion: {
    impossible: 'Connexion impossible',
    oublie: 'Mot de passe oublié ?',
    seConnecter: 'Connexion',
    nouveau: 'Nouveau sur Sirocco ?',
    inscrire: "S'inscrire",
  },
  personnaliser: {
    photoImpossible: 'Photo impossible à enregistrer',
    impossible: 'Enregistrement impossible',
    titre: 'Personnalise ton profil',
    choisirPhoto: 'Choisir ma photo de profil',
    bio: 'Bio',
    bioExemple: "Ce que tu fais ici, ce que tu cherches, ta ville d'avant...",
    continuer: 'Continuer',
  },
  inscription: {
    regles: {
      huit: 'Au moins 8 caractères',
      casse: 'Majuscules et minuscules',
      chiffre: 'Au moins un chiffre ou caractère spécial',
    },
    manque: {
      prenom: 'Indique ton prénom',
      nom: 'Indique ton nom',
      pseudo: "Choisis un nom d'utilisateur",
      email: 'Indique ton adresse e-mail',
      motDePasse: 'Choisis un mot de passe',
      naissance: 'Indique ta date de naissance',
    },
    naissanceInvalide: 'Date de naissance invalide',
    conditions: 'Tu dois accepter les conditions générales',
    impossible: 'Inscription impossible',
    titre: "S'INSCRIRE",
    dejaInscrit: 'Déjà inscrit ?',
    seConnecter: 'Se connecter',
    prenom: 'Prénom',
    nom: 'Nom',
    pseudo: "Nom d'utilisateur",
    pseudoExemple: 'Ex. : martin.pecheur',
    naissance: 'Date de naissance',
    accepteLabel: "J'accepte les conditions générales et la politique de confidentialité de Sirocco",
    accepte: {
      debut: "J'accepte les",
      cgu: 'conditions générales',
      et: 'et la',
      confidentialite: 'politique de confidentialité',
      fin: 'de Sirocco.',
    },
    langues: 'Langues parlées',
    languesAide: 'Les sorties dans tes langues passent en tête de liste. Tu pourras les changer dans ton profil.',
    jeMInscris: "Je m'inscris",
  },
};
